// Add your custom JS here.

// Main Nav hide on scroll down, show on scroll up
/*
document.addEventListener('DOMContentLoaded', () => {
    let lastScrollTop = 0;
    const mainNav = document.getElementById('main-nav');

    window.addEventListener('scroll', () => {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        
        if (scrollTop > lastScrollTop && scrollTop > 500) {
            // Scrolling down and passed 500px from top
            mainNav.classList.add('hidden');
        } else {
            // Scrolling up or not passed 500px from top
            mainNav.classList.remove('hidden');
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }, false);
});
*/

// Import UIKit
// import UIkit from 'uikit';

// Enable Tooltips everywhere
import Tooltip from 'bootstrap/js/dist/tooltip';
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
});

// Loader
/*
document.addEventListener('DOMContentLoaded', () => {
    const loader = document.querySelector('.loader');
    if (!loader) return;
    setTimeout(() => {
        // add class .hide
        loader.classList.add('hide');
    }, 500);
});
*/

// Hero spotlight effect
const heroEl = document.querySelector(".spotlight-hero");
const homeHeroEl = document.querySelector(".home-hero.spotlight-hero");
const spotlightEl = document.querySelector("#radial");
function handleMouseMove(event) {
    const { clientX, clientY } = event;
    setTimeout(() => {
        if (homeHeroEl) {
            spotlightEl.style.background = `radial-gradient(ellipse at ${clientX}px ${clientY}px, rgba(17, 17, 17, 0.7) -100%, rgba(17, 17, 17, 1) 80%)`;
        } else {
            spotlightEl.style.background = `radial-gradient(ellipse at ${clientX}px ${clientY}px, rgba(17, 17, 17, 0.25) -100%, rgba(17, 17, 17, 1) 40%)`;
        }
    }, 100);
}

if (heroEl) {
    heroEl.addEventListener("mousemove", handleMouseMove);
}



// Adding .bg-dark to menu when scrolled down
const mainNav = document.querySelector("#main-nav");
if (window.scrollY > 100) {
    mainNav.classList.add("bg-dark");
} else {
    mainNav.classList.remove("bg-dark");
}
window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
        mainNav.classList.add("bg-dark");
    } else {
        mainNav.classList.remove("bg-dark");
    }
});


// On mouseenter or on focus for the .dropdown-menu element, toggle the .invisible class to .visible
const dropdownMenus = document.querySelectorAll('#main-nav .dropdown');
dropdownMenus.forEach(dropdown => {
    const dropdownMenu = dropdown.querySelector('.dropdown-menu'); // Select the .dropdown-menu element inside the current .dropdown

    // Function to add the 'visible' class to .dropdown-menu
    const showMenu = () => dropdownMenu.classList.add('visible');

    // Function to remove the 'visible' class from .dropdown-menu
    const hideMenu = () => dropdownMenu.classList.remove('visible');

    // Adding event listeners to the .dropdown, affecting the .dropdown-menu
    dropdown.addEventListener('mouseenter', showMenu);
    dropdown.addEventListener('mouseleave', hideMenu);
    dropdown.addEventListener('focusin', showMenu);
    dropdown.addEventListener('focusout', hideMenu);
});

// Hero title corner opacity to 1 on page load
const heroTitle = document.querySelector(".hero-title-corner");
if (heroTitle) {
    window.addEventListener("load", () => {
        heroTitle.style.opacity = 1;
    });
}

// Insert <span> inside .link-arrow-inline on load
const linkArrowInline = document.querySelectorAll(".link-arrow-inline");
linkArrowInline.forEach((el) => {
    el.innerHTML += '<span></span>';
}
);


// Timeline hover effects
const timelineItems = document.querySelectorAll(".timeline-item");
timelineItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
        timelineItems.forEach((item) => {
            item.classList.remove("active");
        });
        item.classList.add("active");
    });
});

// Timeline add .active when timeline-item or service-list-box is in view in the center of the viewport
const timeline = document.querySelector(".timeline");
const timelineItemsArray = Array.from(timelineItems);
const serviceListBoxes = document.querySelectorAll(".service-list-box");
const serviceListBoxesArray = Array.from(serviceListBoxes);
window.addEventListener("scroll", () => {
    timelineItemsArray.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
            timelineItemsArray.forEach((item) => {
                item.classList.remove("active");
            });
            item.classList.add("active");
        }
    });

    serviceListBoxesArray.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
            serviceListBoxesArray.forEach((item) => {
                item.classList.remove("active");
            });
            item.classList.add("active");
        }
    });
});

// Content highlight: add .active when highlight-item is in view in the center of the viewport
const highlightItems = document.querySelectorAll(".highlight-item");
const highlightItemsArray = Array.from(highlightItems);
window.addEventListener("scroll", () => {
    highlightItemsArray.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
            highlightItemsArray.forEach((item) => {
                item.classList.remove("active");
            });
            item.classList.add("active");
        }

        item.addEventListener("mouseenter", () => {
            highlightItemsArray.forEach((item) => {
                item.classList.remove("active");
            });
            item.classList.add("active");
        });
    });
});


// Image 3D hover effect 
let hoverCon = document.querySelector(".hover-3d-con");
let hoverLayer = document.querySelector(".hover-3d-el");
let hoverRegion = document.querySelector(".hover-3d-region");
if (hoverCon, hoverLayer, hoverRegion) {
    let constrain = hoverLayer.getBoundingClientRect().width - 20;

    function transforms(x, y, el) {
        let box = el.getBoundingClientRect();
        let calcX = -(y - box.y - (box.height / 2)) / constrain;
        let calcY = (x - box.x - (box.width / 2)) / constrain;

        return "perspective(" + hoverLayer.getBoundingClientRect().width + "px) "
            + "   rotateX(" + calcX + "deg) "
            + "   rotateY(" + calcY + "deg) ";
    };

    function transformElement(el, xyEl) {
        el.style.transform = transforms.apply(null, xyEl);
    }

    hoverRegion.onmousemove = function (e) {
        let xy = [e.clientX, e.clientY];
        let position = xy.concat([hoverLayer]);

        window.requestAnimationFrame(function () {
            transformElement(hoverLayer, position);
        });
    };
}


const helpForm = document.getElementById('helpform');
if (helpForm) {
    helpForm.addEventListener('submit', function(e) {
        const form = e.target;

        // Maps from value to label
        const goalLabelsMap = {
            leads: 'attract more qualified leads',
            revenue: 'increase revenue from online sales',
            awareness: 'build a positive reputation',
            engagement: 'drive more online engagement'
        };

        const needLabelsMap = {
            strategy: 'marketing strategy',
            creative: 'creative production',
            seo: 'search engine optimization',
            development: 'website development',
            paid: 'paid media management',
            analytics: 'analytics and reporting',
            unsure: "I'm not sure what services I need"
        };

        // Get checked goal values and map to labels
        const goalLabels = Array.from(form.querySelectorAll('input[name="goals[]"]:checked'))
            .map(cb => goalLabelsMap[cb.value] || cb.value);

        // Get checked need values
        const checkedNeedValues = Array.from(form.querySelectorAll('input[name="needs[]"]:checked'))
            .map(cb => cb.value);

        const hasUnsure = checkedNeedValues.includes('unsure');

        // Map needs to labels (excluding 'unsure' for sentence building)
        const needLabels = checkedNeedValues
            .filter(val => val !== 'unsure')
            .map(val => needLabelsMap[val] || val);

        // Build goal sentence
        let goalsString = '';
        if (goalLabels.length > 0) {
            if (goalLabels.length === 1) {
                goalsString = 'I want to ' + goalLabels[0] + '.';
            } else {
                const last = goalLabels.pop();
                goalsString = 'I want to ' + goalLabels.join(', ') + ', and ' + last + '.';
            }
        }

        // Build needs sentence
        let needsString = '';
        if (hasUnsure && needLabels.length === 0) {
            needsString = "I'm not sure what services I need.";
        } else if (needLabels.length > 0) {
            if (needLabels.length === 1) {
                needsString = 'I need help with ' + needLabels[0] + '.';
            } else {
                const last = needLabels.pop();
                needsString = 'I need help with ' + needLabels.join(', ') + ', and ' + last + '.';
            }

            if (hasUnsure) {
                needsString += ' I’m not sure what other services I need.';
            }
        }

        // Final message
        const message = goalsString + ' ' + needsString;

        // Optional debug
        // alert('Message:\n' + message);

        // Set action URL
        const baseAction = '/for-you/';
        const query = '?message=' + encodeURIComponent(message.trim());
        form.action = baseAction + query;
    });
}


// jQuery specifc code
jQuery(function ($) {
    // Menu Search Bar
    const searchToggler = $('#searchToggler');
    const searchInput = $('#searchInput');
    const searchInputEl = $('#searchInput input');
    $(searchToggler).on('click', function (event) {
        event.preventDefault();
        if ($(searchInput).is(':visible')) {
            // If #searchInput is visible, reverse the order
            $(searchInput).fadeOut(100, function () {
                $('#menuContainer').fadeIn();
            });
        } else {
            // If #searchInput is not visible, execute as before
            $('#menuContainer').fadeToggle(100, function () {
                $(searchInput).fadeIn();
                const x = window.scrollX;
                const y = window.scrollY;
                $(searchInputEl).focus();
                window.scrollTo(x, y);
            });
        }
    });

    // Hide search bar when clicking outside of it
    $(document).on('click', function (event) {
        if (searchToggler.is(':visible') && searchInput.is(':visible') && !searchInput.is(event.target) && !searchInput.has(event.target).length) {
            // Click is outside of #searchInput, hide it and show .menu-col
            searchInput.fadeOut(100, function () {
                $('#menuContainer').fadeIn();
            });
        }
    });

    // Scrollspy for Guides block
    $('body').scrollspy({ target: '#tableContents', offset: 200 });

    // fire the OSEO modal on page load if present
    if ($('#oseoModal').length) {
        $('#oseoModal').modal('show');
    }


    // Smooth anchor scrolling
    $('a').click(function () {
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 140
        }, 0, 'linear');
        return false;
    });


    //////////////////////////
    //      HELP FORM       //
    //////////////////////////

    // Checkboxes change handler
    $('.form-panel .goal-checkbox, .form-panel .need-checkbox').on('change', function () {
        var panel = $(this).closest('.form-panel');
        var checkboxes = panel.find('input[type="checkbox"]:checked');
        var nextBtn = panel.find('.next-btn');

        // Enable/disable next button based on checked checkboxes
        if (checkboxes.length > 0) {
            nextBtn.prop('disabled', false);
        } else {
            nextBtn.prop('disabled', true);
        }
    });

    // Next button click handler
    $('.next-btn').on('click', function () {
        var currentPanel = $(this).closest('.form-panel');
        var nextPanel = currentPanel.next('.form-panel');
        currentPanel.removeClass('show').addClass('hide');
        nextPanel.removeClass('hide').addClass('show');
        $('html, body').animate({
            scrollTop: $('#helpform').offset().top - 250
        }, 200);
    });

    // Back button click handler
    $('.back-btn').on('click', function () {
        var currentPanel = $(this).closest('.form-panel');
        var prevPanel = currentPanel.prev('.form-panel');
        currentPanel.removeClass('show').addClass('hide');
        prevPanel.removeClass('hide').addClass('show');
        $('html, body').animate({
            scrollTop: $('#helpform').offset().top - 250
        }, 200);
    });


    //////////////////////////
    //    Ajax Filtering    //
    //////////////////////////
    var currentPage = 1;

    // Insights
    function filterInsights() {
        if ($('select[name="cat"]').length > 0) {
            var selectedCat = $('select[name="cat"] option:selected').val();
        } else {
            var selectedCat = '';
        }
        var selectedCat = $('select[name="cat"] option:selected').val();
        var hideArchived = $('#queryfeed').data('hide-archived');
        var originalID = $('#queryfeed').data('original-id');
        var postsPerPage = $('#queryfeed').data('ppp');
        var feedType = $('#queryfeed').data('feed-type');
        var industry = $('#queryfeed').data('industry');

        // Scroll to top of feed
        if ($('#filter').length > 0) {
            $('html, body').animate({
                scrollTop: $('#filter').offset().top - 200
            }, 200);
        } else {
            $('html, body').animate({
                scrollTop: $('#queryfeed').offset().top - 200
            }, 200);
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php', // WordPress provides the 'ajaxurl' global variable
            type: 'post',
            data: {
                action: 'filter_insights',
                page: currentPage,
                hide_archived: hideArchived,
                original_id: originalID,
                posts_per_page: postsPerPage,
                feed_type: feedType,
                cat: selectedCat,
                industry: industry
            },
            beforeSend: function () {
                $('#queryfeed').html('<div class="col-12 text-center py-12"><div class="loader anim-fast z-1"><svg id="f-loader" width="130" height="199" viewBox="0 0 130 199" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M121 107V141.5H77.5V190H0" stroke="#C8202F" stroke-width="18"/><path d="M9 0V161" stroke="#C8202F" stroke-width="18"/><path d="M43 9H121V76H67" stroke="#C8202F" stroke-width="18"/></svg></div></div>');
            },
            success: function (response) {
                setTimeout(() => {
                    $('#queryfeed').html(response);
                }, 900);
            }
        });
    }
    $('#filter select[name="cat"').on('change', function () { currentPage = 1; filterInsights() });

    // Pagination handling
    $(document).on('click', '.block-insights-feed .pagination a', function (e) {
        e.preventDefault();
        currentPage = $(this).attr('data-page'); // Update the page number from pagination links
        filterInsights();
    });
});